import { getCompany } from "../../../../infrastructure/common/repositories/getCompany";

export default function findCompany() {
  return getCompany();
}
